// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo[data-v-4ef0a45b] {\n  display: block;\n}\n.logo__wrap[data-v-4ef0a45b] {\n  display: block;\n}\n.logo__img[data-v-4ef0a45b] {\n  display: block;\n  margin: 0 auto;\n  width: 100%;\n  height: auto;\n}", ""]);
// Exports
module.exports = exports;
